import { a as TailwindElement, x } from '../../index-e3189942.js';
import { e, a as e$1 } from '../../directive-9ec64c08.js';
import { t } from '../../state-7fde94d1.js';
import { c as customClassMap } from '../../index-714323c9.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let LuksoNavbar = class extends TailwindElement {
  constructor() {
    super(...arguments);
    this.title = "";
    this.isCenter = false;
    this.isSticky = false;
    this.isTransparent = false;
    this.isMenuOpen = false;
    this.centerStyles = `justify-center`;
    this.stickyStyles = `sticky top-0 z-[1000]`;
    this.transparentStyles = `!bg-transparent !shadow-none`;
  }
  handleBrandClick() {
    const event = new CustomEvent("on-brand-click", {
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(event);
  }
  handleMenuToggle() {
    this.isMenuOpen = !this.isMenuOpen;
  }
  desktopMenuTemplate() {
    return x`<div
      class="w-full items-center justify-end pr-10 no-underline hidden md:flex"
    >
      <slot name="desktop"></slot>
    </div>`;
  }
  mobileMenuTemplate() {
    return x`<div
      class="w-full items-center justify-end pr-6 flex md:hidden"
    >
      <div
        class="flex items-center justify-center w-8 h-8 cursor-pointer"
        @click=${this.handleMenuToggle}
      >
        <div
          class="w-[18px] h-[2px] rounded-4 bg-neutral-20 transition-all
        before:content-[''] before:absolute before:w-[18px] before:h-[2px] before:bg-neutral-20 before:rounded-4 before:transition-all before:-translate-y-[6px]
        after:content-[''] after:absolute after:w-[18px] after:h-[2px] after:bg-neutral-20 after:rounded-4 after:transition-all after:translate-y-[6px]
        ${customClassMap({
      "!bg-transparent before:rotate-[45deg] before:!-translate-y-[0px] after:-rotate-[45deg] after:!translate-y-[0px]": this.isMenuOpen
    })}
      "
        ></div>
      </div>
      <div
        class="fixed top-[78px] left-0 w-full h-full bg-neutral-100 z-[1000] justify-center
      items-center flex md:hidden
    ${customClassMap({
      "animate-fade-in animation-duration-150": this.isMenuOpen,
      "!hidden": !this.isMenuOpen
    })}"
        @click=${this.handleMenuToggle}
      >
        <slot name="mobile"></slot>
      </div>
    </div>`;
  }
  render() {
    return x`
      <nav
        data-testid="navbar"
        class="bg-neutral-100 shadow-pink-drop-shadow h-78 flex
        ${customClassMap({
      [this.centerStyles]: this.isCenter,
      [this.stickyStyles]: this.isSticky,
      [this.transparentStyles]: this.isTransparent
    })}"
      >
        <div
          class="flex items-center px-7 h-full cursor-pointer sm:px-10"
          @click=${this.handleBrandClick}
        >
          <img src="/assets/images/lukso-logo.svg" class="mr-4" />
          <div
            class="text-purple-51 nav-apax-14-medium-uppercase
              whitespace-pre-line flex leading-none hover:text-purple-41"
          >
            <span>${this.title}</span>
          </div>
        </div>
        ${this.isCenter ? x`` : x`${this.desktopMenuTemplate()} ${this.mobileMenuTemplate()}`}
      </nav>
    `;
  }
};
__decorateClass([
  e({ type: String })
], LuksoNavbar.prototype, "title", 2);
__decorateClass([
  e({ type: Boolean, attribute: "is-center" })
], LuksoNavbar.prototype, "isCenter", 2);
__decorateClass([
  e({ type: Boolean, attribute: "is-sticky" })
], LuksoNavbar.prototype, "isSticky", 2);
__decorateClass([
  e({ type: Boolean, attribute: "is-transparent" })
], LuksoNavbar.prototype, "isTransparent", 2);
__decorateClass([
  t()
], LuksoNavbar.prototype, "isMenuOpen", 2);
LuksoNavbar = __decorateClass([
  e$1("lukso-navbar")
], LuksoNavbar);

export { LuksoNavbar };
